<template>
	<div>
		<div :style="`background-color:${theme.backGround.color};`" class="pd-b-1 text-center disable-print">
			<div class="container">
				<div class="column dp-menu-action has-text-right is-hidden-desktop" v-if="user != null">
                    <b-dropdown aria-role="list" position="is-bottom-left" v-if="user != null">
			            <button class="button has-text-white dp-btn-noBg" slot="trigger" slot-scope="{ active }">
							<div class="box-profile" v-if="user.profileImage != null">
								<div >
									<img :src="urlImg+user._id+'/'+user.profileImage" alt="">
								</div>
							</div>
			                <figure v-else class=" is-rounded image has-background-white is-32x32 mg-r-4 is-flex ai-center js-center">
								  <i class="fas fa-user fa-sm" :style="`color:${theme.backGround.color};`"></i>
							</figure><span >{{user.name}}</span>
			                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
			            </button>
			            <b-dropdown-item class="dp-item-normal mg-y-5 is-size-6  has-text-centered" aria-role="listitem" >
			            	<router-link target="_blank" to="/changelog" class="has-text-centered">
			            		Change Log
			            	</router-link>
			            </b-dropdown-item>
			            <b-dropdown-item class="dp-item-normal mg-y-5 has-text-centered is-size-6 " @click="signout" aria-role="listitem">ออกจากระบบ</b-dropdown-item>
			        </b-dropdown>
				</div>
				<div class="columns is-vcentered">
					<div class="column is-flex  ai-center " :class="maxWidth > 768 ? 'js-start pd-y-3':'js-center pd-t-3'">
						<a href="/">
							<img v-if="user != null" @error="$event.target.src = `${baseUrl}logo/logo-ace-form.png`" :src="imgUrl+theme.text.logo">
							<img v-else @error="$event.target.src = `${baseUrl}logo/logo-ace-form.png`" src="@/assets/logo-ace-form.png">
						</a>
					</div>
					<div class="column is-text-white" :class="maxWidth > 768 ? 'pd-t-3':''">
						<div>
							<h2 class="is-size-5-mobile">{{theme.text.title}}</h2>
							<h3 class="is-size-6-mobile">{{theme.text.subTitle}}</h3>
						</div>
					</div>
					<div class="column dp-menu-action has-text-right is-hidden-mobile" v-if="user != null">
                        <b-dropdown aria-role="list" position="is-bottom-left" v-if="user != null">
				            <button class="button has-text-white dp-btn-noBg mg-b-4" slot="trigger" slot-scope="{ active }">
								<div class="box-profile size-m mg-r-4" v-if="user.profileImage != null">
									<div >
									<img :src="urlImg+user._id+'/'+user.profileImage" alt="">
									</div>
								</div>
				                <figure v-else class=" is-rounded image has-background-white is-48x48 mg-r-4 is-flex ai-center js-center">
								  <i class="fas fa-user fa-lg" :style="`color:${theme.backGround.color};`"></i>
								</figure><span >{{user.name}}</span>
				                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
				            </button>
							<b-dropdown-item class="dp-item-normal mg-y-5 is-size-6  has-text-centered" aria-role="listitem" v-if="user.userLevel == 60">
				            	<router-link :to="`/manage-user`" class="has-text-centered">
				            		จัดการข้อมูลผู้ใช้
				            	</router-link>
				            </b-dropdown-item>
							<b-dropdown-item class="dp-item-normal mg-y-5 is-size-6  has-text-centered" aria-role="listitem" >
				            	<router-link :to="`/edit-profile`" class="has-text-centered">
				            		แก้ไขข้อมูลส่วนตัว
				            	</router-link>
				            </b-dropdown-item>
				            <b-dropdown-item class="dp-item-normal mg-y-5 is-size-6  has-text-centered" aria-role="listitem" >
				            	<router-link target="_blank" to="/changelog" class="has-text-centered">
				            		Change Log
				            	</router-link>
				            </b-dropdown-item>
				            <b-dropdown-item class="dp-item-normal mg-y-5 has-text-centered is-size-6 " @click="signout" aria-role="listitem">ออกจากระบบ</b-dropdown-item>
				        </b-dropdown>
					</div>
				</div>
			</div>
		</div>
		<div id="body" class="mh-fullscreen">
			<div class="bg-curve bg-top disable-print" :style="`background-color:${theme.backGround.color};`"></div>
			<div class="container slot-page" style="margin-top:-250px;">
				<slot></slot>
			</div>
		</div>
		<div id="footer" class="mg-b-3 disable-print" :class="maxWidth > 768 ? 'mg-t-1':'mg-t-5'">
			<div class="container">
				<div class="columns is-flex">
					<div class="column is-5-mobile" :class="maxWidth > 768 ? '':'pd-3'">
						<img src="@/assets/logo-footer.png">
					</div>
					<div class="column is-7-mobile is-flex ai-center js-end" :class="maxWidth > 768 ? '':'pd-3'">
						<p>Powered by <a :href="url">ACE Form.</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { HTTP } from "@/service/axios.js";
	export default{
		computed:{
			user(){
				return this.$store.state.user
			}
		},
		data(){
			return {
				urlImg:process.env.VUE_APP_IMAGE_USER,
				maxWidth: window.innerWidth,
				baseUrl:process.env.VUE_APP_BASE_URL,
				url:process.env.VUE_APP_URL,
				imgProfile:process.env.VUE_APP_IMAGE_URL,
				imgUrl:process.env.VUE_APP_IMAGE_DEPARTMENT_URL
			}
		},
		methods:{
			async signout() {
		      setTimeout(() => {
		        window.localStorage.clear();
		      }, 200);
		      this.$store.commit("SIGNOUT");
		      window.localStorage.removeItem("ace-form");
		      delete HTTP.defaults.headers.common.Authorization;
		      this.$router.push("/signin");
		    },
		}
	}
</script>
<style scoped>
	.bg-top{
		height: 230px;
	}
	.bg-curve{
		background-image: url('../assets/bg-sign-larg.png');
		background-position: bottom center; 
		background-repeat: no-repeat;
	}
	.button.dp-btn-noBg:hover{
		color: #fff!important;
	}
</style>